module.exports = __webpack_public_path__ + "static/media/Tosa.1b8370c7.webp";